"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var rc_slider_1 = tslib_1.__importDefault(require("rc-slider"));

var styles = tslib_1.__importStar(require("./Slider.style"));

require("rc-slider/assets/index.css"); // TODO: Tooltip 커스텀 필요


function Slider(_ref) {
  var className = _ref.className,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 10 : _ref$max,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      _ref$reverse = _ref.reverse,
      reverse = _ref$reverse === void 0 ? false : _ref$reverse,
      onChange = _ref.onChange,
      onAfterChange = _ref.onAfterChange;

  var _react_1$useState = react_1.useState(value),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      range = _react_1$useState2[0],
      setRange = _react_1$useState2[1];

  function handleOnChanged(draftValue) {
    setRange(draftValue);
    onChange && onChange(draftValue);
  }

  function handleOnAfterChanged(draftValue) {
    setRange(draftValue);
    onAfterChange && onAfterChange(draftValue);
  }

  react_1.useEffect(function () {
    setRange(value);
  }, [value]);
  var RCSliderComponent = rc_slider_1.default;
  return jsx_runtime_1.jsx("div", Object.assign({
    className: className,
    css: styles.wrapper
  }, {
    children: jsx_runtime_1.jsx(RCSliderComponent, {
      min: min,
      max: max,
      step: step,
      value: range,
      reverse: reverse,
      onChange: handleOnChanged,
      onAfterChange: handleOnAfterChanged
    }, void 0)
  }), void 0);
}

exports.default = Slider;